import type { ChampionRegion } from "./champions";
import type { EnemyId } from "./enemies";
import type { MapNodeWeights } from "../map/MapGenerator";

export interface ActDef {
  number: number;
  name: string;
  region: ChampionRegion;
  champCount: number; // how many region champions appear in a boss fight
  minionMobs: EnemyId[];
  nodeWeights?: Partial<MapNodeWeights>;
  levelOffset?: number; // added to the base enemy level for this act (can be negative)
}

export const ACTS: readonly ActDef[] = [
  {
    number: 1,
    name: "Freljord",
    region: "freljord",
    champCount: 2,
    minionMobs: ["minion"],
    nodeWeights: { minion: 28, jungle: 28, recruit: 18 },
  },
  {
    number: 2,
    name: "Demacia",
    region: "demacia",
    champCount: 3,
    minionMobs: ["minion"],
    nodeWeights: { minion: 28, jungle: 28, recruit: 14 },
  },
  {
    number: 3,
    name: "Noxus",
    region: "noxus",
    champCount: 4,
    minionMobs: ["minion"],
    nodeWeights: { minion: 28, jungle: 28, recruit: 12 },
    levelOffset: -2,
  },
  {
    number: 4,
    name: "Piltover & Zaun",
    region: "piltover",
    champCount: 5,
    minionMobs: ["minion"],
    nodeWeights: { minion: 28, jungle: 28, recruit: 10 },
  },
  {
    number: 5,
    name: "Ixtal",
    region: "ixtal",
    champCount: 3,
    minionMobs: ["minion"],
    nodeWeights: { minion: 28, jungle: 28, recruit: 8 },
  },
  {
    number: 6,
    name: "Shurima",
    region: "shurima",
    champCount: 5,
    minionMobs: ["minion"],
    nodeWeights: { minion: 10, jungle: 28, recruit: 6 },
  },
  {
    number: 7,
    name: "Targon",
    region: "targon",
    champCount: 5,
    minionMobs: ["redBuff"],
    nodeWeights: { minion: 8, jungle: 28, recruit: 4 },
  },
];

export const FINAL_ACT = ACTS[ACTS.length - 1];

export function getAct(number: number): ActDef {
  const act = ACTS.find((a) => a.number === number);
  if (!act) throw new Error(`Invalid act number: ${number}`);
  return act;
}
